import { render, staticRenderFns } from "./editStoretag.vue?vue&type=template&id=6f0eb794&scoped=true"
import script from "./editStoretag.vue?vue&type=script&lang=js"
export * from "./editStoretag.vue?vue&type=script&lang=js"
import style0 from "./editStoretag.vue?vue&type=style&index=0&id=6f0eb794&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0eb794",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f0eb794')) {
      api.createRecord('6f0eb794', component.options)
    } else {
      api.reload('6f0eb794', component.options)
    }
    module.hot.accept("./editStoretag.vue?vue&type=template&id=6f0eb794&scoped=true", function () {
      api.rerender('6f0eb794', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/goodsTag/editStoretag.vue"
export default component.exports